import type {
  FlexboxProps as BaseFlexboxProps,
  GridProps as BaseGridProps,
  MaxWidthProps as BaseMaxWidthProps,
  MinWidthProps as BaseMinWidthProps,
  RequiredTheme,
  ResponsiveValue,
  SpaceProps as BaseSpaceProps,
  Theme as SystemTheme,
  ThemeValue,
  WidthProps as BaseWidthProps,
} from 'styled-system'
import { system } from 'styled-system'

import { Theme } from './types'

// CSS 'gap' property to use in grid and flexbox
// We can safely remove this when styled-system supports it
export const gap = system({
  gap: {
    property: 'gap',
    scale: 'space',
  },
  gapX: {
    property: 'columnGap',
    scale: 'space',
  },
  gapY: {
    property: 'rowGap',
    scale: 'space',
  },
})

interface BaseGapProps<
  ThemeType extends SystemTheme = RequiredTheme,
  TVal = ThemeValue<'space', ThemeType>,
> {
  gap?: ResponsiveValue<TVal, ThemeType> | undefined
  gapX?: ResponsiveValue<TVal, ThemeType> | undefined
  gapY?: ResponsiveValue<TVal, ThemeType> | undefined
}

export type GapProps = BaseGapProps<Theme, number>

// A custom 'columns' syntax sugar for the CSS 'grid-template-columns' property
export const columns = system({
  columns: {
    property: 'gridTemplateColumns',
    transform: (value: number | string) =>
      typeof value === 'string' ? value : `repeat(${value}, 1fr)`,
  },
})

interface BaseColumnsProps<
  ThemeType extends SystemTheme = RequiredTheme,
  TVal = ThemeValue<'space', ThemeType>,
> {
  columns?: ResponsiveValue<TVal, ThemeType> | undefined
}

export type ColumnsProps = BaseColumnsProps<Theme, number>

export { flexbox, grid, maxWidth,minWidth, space, width } from 'styled-system'

export type SpaceProps = BaseSpaceProps<Theme, number | 'auto'>
export type FlexboxProps = BaseFlexboxProps<Theme>
export type GridLayoutProps = BaseGridProps<Theme>
export type WidthProps = BaseWidthProps<Theme>
export type MinWidthProps = BaseMinWidthProps<Theme>
export type MaxWidthProps = BaseMaxWidthProps<Theme>
